<template>
  <z-expansion-config-item 
    titulo="Dashboard Resumido" 
    subtitulo="Exibir o dashboard resumido na tela inicial do sistema"
  >
    <v-switch
      v-model="store.configuracoes.DASHBOARD_RESUMIDO"
      :label="store.configuracoes.DASHBOARD_RESUMIDO ? 'Ativado' : 'Desativado'"
      left
      hide-details
      class="mt-0 pt-0 switch-reverse"
      @change="updateConfig"
    ></v-switch>
  </z-expansion-config-item>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'

const store = useConfigStore();

const { proxy } = getCurrentInstance();



async function updateConfig() {
  await store.salvarConfiguracao({
    config: 'DASHBOARD_RESUMIDO',
    valor: store.configuracoes.DASHBOARD_RESUMIDO,
    tipo: 'boolean',
    descricao: 'Dashboard Resumido',
    ajuda: 'Exibir o dashboard resumido na tela inicial do sistema'
  });

  proxy.$store.dispatch("carregarConfiguracoes");
}

</script>

<style lang="scss" scoped>

.switch-reverse :deep(.v-input__slot) {
  flex-direction: row-reverse;

  label {
    width: 100px;
  }
}

</style>
